
import { Button } from "@/components/ui/button";
import { Plus, RefreshCw } from "lucide-react";

interface AgentListHeaderProps {
  isLoading: boolean;
  onRefresh: () => void;
  onCreateNew: () => void;
}

export const AgentListHeader = ({ isLoading, onRefresh, onCreateNew }: AgentListHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-lg font-medium">AI Agents</h3>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onRefresh}
          disabled={isLoading}
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${isLoading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
        <Button 
          size="sm" 
          onClick={onCreateNew}
        >
          <Plus className="h-4 w-4 mr-2" />
          New Agent
        </Button>
      </div>
    </div>
  );
};
